import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  FormGroup,
  Form,
  Input,
  Button,
} from 'reactstrap';
import { useDispatch } from "react-redux";
import { useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';
import { actionAssetSubmitForm, actionAssetSubmitEdition } from 'store/actions/assetsActions';
import { translate } from "react-translate";
import { actionSetEditAsset, actionGetAssetTypes } from 'store/actions/assetsActions';

const AssetsForm = (props) => {
  const dispatch = useDispatch();
  const { t } = props;

  //States
  const assetData = useSelector(state => state.assetsReducer.assetEdit);
  const types = useSelector(state => state.assetsReducer.types);
  const [assetType, setAssetType] = useState(assetData.asset_type);
  
  const { register, handleSubmit } = useForm({
    defaultValues: {
      asset_type: assetData.asset_type,
      study_type: assetData.study_type,
      serial_number: assetData.serial_number,
      brand: assetData.brand,
      model: assetData.model,
      identifier: assetData.identifier,
      features: assetData.features
    }
  });
  const history = useHistory();

  const onSubmit = (data) => {
    if (Object.keys(assetData).length) {
      dispatch(actionAssetSubmitEdition({...data, assetId: assetData._id}));
    } else {
      dispatch(actionAssetSubmitForm({...data}));
    }
    history.goBack();
  };

  useEffect(() => {

    if (!Object.keys(types).length) {
      dispatch(actionGetAssetTypes());
    }
    return () => {
      dispatch(actionSetEditAsset({}));
    }
  }, []);


  return (
    <div className="content user-manual-edit mt-3">

      <Card>
        <CardHeader>{Object.keys(assetData).length ? `Editing asset ${assetData._id}...` : "New asset"}</CardHeader>
        <CardBody>

        <Form id="asset-form" onSubmit={handleSubmit(onSubmit)}>
           <FormGroup>
            <Label for="asset_type">{t("type")}</Label>
            <Input 
              className={""}
              type="select" 
              name="asset_type" 
              id="asset_type"
              onChange={(e) => {setAssetType(e.target.value)}}
              innerRef={register}
            >
              <option value={"cellphone"}>Cellphone</option>
              <option value={"sim card"}>SIM card</option>
              <option value={"device"}>Device</option>
            </Input>


            {assetType === "device" ? 
            <>
              <Label for="study_type">{t("study-type")}</Label>
              <Input 
                className={""}
                type="select" 
                name="study_type" 
                id="study_type"
                innerRef={register}
              >
                {Object.keys(types).map((t,i) => {
                  return <option key={`type-${i}`} value={types[t]}>{types[t]}</option>
                })}
              </Input>
            </> : <></>}

            <Label for="brand">{t("brand")}</Label>
            <Input 
              className={""}
              type="text" 
              name="brand" 
              id="brand"
              innerRef={register}
            >
            </Input>

            <Label for="serial_number">{t("serial")}</Label>
            <Input 
              className={""}
              type="text" 
              name="serial_number" 
              id="serial_number"
              innerRef={register}
            >
            </Input>

            <Label for="model">{t("model")}</Label>
            <Input 
              className={""}
              type="text" 
              name="model" 
              id="model"
              innerRef={register}
            >
            </Input>

            <Label for="identifier">{t("identifier")}</Label>
            <Input 
              className={""}
              type="text" 
              name="identifier" 
              id="identifier"
              innerRef={register}
            >
            </Input>

            <Label for="features">{t("features")}</Label>
            <Input 
              className={""}
              type="textarea" 
              name="features" 
              id="features"
              innerRef={register}
            >
            </Input>
          </FormGroup>

        </Form>

          <Button form="asset-form" size="sm" color="info" type="submit">
            Update
          </Button>

          <Button
            form="asset-form"
            size="sm"
            color="danger"
            type="reset"
            onClick={(e) => {
              e.preventDefault();
              history.goBack();
            }}
          >
            Cancel
          </Button>
        </CardBody>
      </Card>
    </div>
  );
};

export default translate("assets")(AssetsForm);
